<template>
  <div id="GoodsList">
    <div class="list_slide_box">
      <div class="slide_box" v-for="(item, index) in list" :key="index">
        <!-- {{item}} -->
        <!-- <span class="favorite" :class="item.IsAttention ? 'on' : ''"></span> -->
        <router-link :to="{path:'/carddetails/'+item.ID}">
          <div class="like_box">
            <el-image class="like_img" :src="item.TitImg!='没有可上传的图片'?item.TitImg+'?imageView2/2/w/200':'../static/images/noimg.svg'" fit="contain"></el-image>
          </div>
          <div class="slide_txt">
            <p class="line_txt3">{{item.Title}}</p>
            <div class="price" :class="StatusNum==2?'text_greed':''">{{areaSymbol}} {{ item.USD_Price }}</div>
            <!-- <span class="fare">$ {{ item.yunfei }} Shipping</span> -->

        <div class="bids_box">
          <span v-if="item.ByWay!=1" class="icon_auction" :class="getCountDown(item.EffectiveDate)==1?'text_red':''">{{ item.AuctionCount }} {{item.AuctionCount != 1?$t('base.bids'):$t('base.bid')}}</span>
          <span v-else class="icon_flash" :class="getCountDown(item.EffectiveDate)==1?'text_red':''">{{$t('base.buyNow')}}</span>
          <span v-if="item.ByWay!=1" class="icon_hour">{{ CountDown(item.EffectiveDate)}}</span>
          <!-- <span class="icon_hour">{{item.EffectiveTime|chooseTime}}</span> -->
        </div>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import { countDown,setUTC } from "@/api/public";
export default {
  name: "goodslist",
  data() {
    return {
      areaSymbol: this.$store.state.areaSymbol,
      timer: "",
      nowData: new Date().getTime(),
    };
  },
  props: {
    list: {},
    StatusNum: ""
  },
  created() {
    this.cardTimer();
  },
  methods: {
    cardTimer() {
      this.timer = setInterval(() => {
        this.nowData = this.nowData + 1000;
      }, 1000);
    },
    getCountDown(itemEnd) {
      itemEnd = itemEnd.toString().replace(/-/g, "/")
      let val = setUTC(itemEnd, -8,'cn')
      let newval = setUTC(this.nowData, -8)
      return countDown(val, newval, 0)
    },
    CountDown(itemEnd) {
      itemEnd = itemEnd.toString().replace(/-/g, "/")
      let val=setUTC(itemEnd,-8,'cn')
      let newval=setUTC(this.nowData, -8)
      return countDown(val, newval)
    },
  },
  //离开页面后清除定时器
  destroyed() {
    clearInterval(this.timer);
  }
};

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../../static/css/goodslist.css";

</style>



// WEBPACK FOOTER //
// src/components/list/headerwatch.vue